<template>
    <div>
        <div class="main-title">
            <h1 class="main">{{t('campaigns_report.title')}}</h1>
            <div class="action-buttons">
                <button class="action-refresh-button" @click="loadData"></button>
            </div>
        </div>

        <table><tbody>
            <tr>
                <th>{{t('campaigns_report.select_project')}}</th>
                <td>
                    <select v-model="projectId" @change="changeProjectId">
                        <option v-for="(project, index) in projects"
                                :value="project.id"
                                :disabled="noCampaigns.includes(index)"
                        >{{project.name}}</option>
                    </select>
                </td>
            </tr>
            <tr>
                <th>{{t('campaigns_report.counted_continue_reason')}}</th>
                <td>
                    <select v-model="continueReasonToCount">
                        <option v-for="reason in continueReasons"
                                :value="reason.id"
                        >{{reason.name}}</option>
                    </select>
                </td>
            </tr>
        </tbody></table>
        <campaign-component
                v-for="(camp, index) in campaigns"
                :key="camp.campaign_id"
                :name="camp.name"
                :camp-data="campaignsData[index] || {continue_reasons: []}"
                :call-sessions="callSessions[index] || {}"
                :reason-to-count="continueReasons.find(x => x.id === continueReasonToCount)"
        >

        </campaign-component>
    </div>
</template>

<script>

    import axios from 'axios';
    import App from '../../App.js';
    import {t} from '../../i18n/i18n.js';
    import CampaignComponent from './CampaignComponent.vue';
    import MessagePopupView from '../../../controls/MessagePopupView.js';

    export default {
        name: 'CampaignsReportPage',
        components: {CampaignComponent},
        data() {
            return {
                projectId: '',
                projects: [],
                noCampaigns: [],
                campaigns: [],
                campaignsData: [],
                callSessions: [],
                continueReasons: [],
                continueReasonToCount: null,
            }
        },
        watch: {
            continueReasonToCount(newValue) {
              App.setUserSetting('campaigns_report_continue_reason', newValue);
            }
        },
        methods: {
            async loadData() {

                clearInterval(this.refreshInterval);

                this.getContinueReasons();

                const campaigns = await this.getCampaigns();

                if (!campaigns.length) return this.campaigns = [];

                this.setNewInterval();

                await this.getCampaignsData(campaigns.map(x => x['id']));

                this.campaigns = campaigns;

            },
            async getCampaigns() {

                App.AlertUI.showLoader();

                const params = {
                    project_id: this.projectId,
                };

                let result;

                try {

                    const {data} = await axios.get(App.apiUrl('campaigns', params));
                    result = data;

                } catch (err) {
                    this.campaigns = [];
                    App.showXhrError(err.request, err);
                }

                App.AlertUI.hideLoader();

                if (!result.length) {
                    const projectIndex = this.projects.findIndex(project => project.id === this.projectId);
                    this.noCampaigns.push(projectIndex);

                    new MessagePopupView({addClass: 'info', message: t('campaigns_report.no_campaigns_message'), queue: true, dismissAfter: 2000}).show();
                }

                return result;

            },
            async getCampaignsData(campaigns) {

                try {

                    const {data} = await axios.get(App.apiUrl('campaigns/stat', {campaigns}));

                    this.campaignsData = data['campaignStats'];
                    this.callSessions = data['callSessionStats'];

                } catch (err) {
                    this.campaignsData = [];
                    App.showXhrError(err.request, err);
                }

            },
            async getContinueReasons() {

                const params = {
                    project_id: this.projectId,
                    defaults: true
                };

                try {

                    const {data} = await axios.get(App.apiUrl('continue_reasons', params));

                    this.continueReasons = data;
                    const savedReason = App.getUserSetting('campaigns_report_continue_reason');

                    if (this.continueReasonToCount &&
                        data.find(x => x.id === this.continueReasonToCount)) return;

                    if (!savedReason || !data.find(x => x.id === savedReason))
                      return this.continueReasonToCount = data[0].id;

                    this.continueReasonToCount = savedReason;


                } catch (err) {
                    this.continueReasons = [];
                    console.log(err);
                }

            },
            changeProjectId() {
                clearInterval(this.refreshInterval);
                this.loadData();
                App.setUserSetting('campaigns_report_project', this.projectId);
            },
            setNewInterval() {
                clearInterval(this.refreshInterval);
                this.refreshInterval = setInterval(() => this.loadData(), 1000 * 30);
            }
        },

        async created() {

            this.projectId = App.getUserSetting('campaigns_report_project');

            if (!this.projectId) {
                const {data: {id: projectId}} = await axios.get(App.apiUrl('me/assigned_project'));
                this.projectId = projectId;
            }

            const {data} = await axios.get(App.apiUrl('projects'));
            this.projects = data;

            this.loadData();

        },
        beforeDestroy () {
            clearInterval(this.refreshInterval)
        },

    }
</script>